/** Left-rail navigation structure. The view→component map lives in App.tsx. */

export interface NavItem {
  id: string;
  label: string;
  tag?: string;
}
export interface NavGroup {
  group: string;
  items: NavItem[];
}

export const NAV: NavGroup[] = [
  { group: 'Overview', items: [{ id: 'dashboard', label: 'Dashboard' }] },
  {
    group: 'Unified',
    items: [
      { id: 'search', label: 'Search' },
      { id: 'u-vehicles', label: 'Vehicles', tag: 'phase 2' },
    ],
  },
  {
    group: 'Products',
    items: [
      { id: 'products', label: 'All products' },
      { id: 'internal', label: 'Internal catalog' },
      { id: 'brands', label: 'Brands' },
      { id: 'import-products', label: 'Import products' },
    ],
  },
  {
    group: 'Kromeda',
    items: [
      { id: 'kr-vehicles', label: 'Vehicles' },
      { id: 'kr-console', label: 'Console' },
      { id: 'kr-log', label: 'Request log' },
    ],
  },
  {
    group: 'TecDoc',
    items: [
      { id: 'td-vehicles', label: 'Vehicles' },
      { id: 'td-console', label: 'Console' },
      { id: 'td-log', label: 'Request log' },
    ],
  },
  {
    group: 'Curated data',
    items: [
      { id: 'xref-oe', label: 'Cross OE → part' },
      { id: 'xref-pp', label: 'Cross part ↔ part' },
      { id: 'anticross', label: 'Anticross OE → part' },
      { id: 'anticross-pp', label: 'Anticross part ↔ part' },
      { id: 'import', label: 'Import & export' },
    ],
  },
  {
    group: 'Normalized store',
    items: [
      { id: 'parts', label: 'Parts' },
      { id: 'oe-codes', label: 'OE codes' },
      { id: 'links', label: 'OE ↔ part links' },
    ],
  },
  {
    group: 'System',
    items: [
      { id: 'cache', label: 'Cache' },
      { id: 'log', label: 'Request log' },
      { id: 'stats', label: 'Statistics' },
      { id: 'settings', label: 'Settings' },
    ],
  },
];

/**
 * id → [group, label] for the topbar breadcrumb + title.
 *
 * `product` is not in the rail — it is only ever reached by opening a row — but it
 * still needs a title, so it is added here by hand.
 */
export const TITLES: Record<string, [string, string]> = {
  ...Object.fromEntries(NAV.flatMap((g) => g.items.map((it) => [it.id, [g.group, it.label] as [string, string]]))),
  product: ['Products', 'Product'],
};
